module.exports = __webpack_public_path__ + "static/media/triangle-left.e7379f75.svg";